// 组织架构
import request from "@/utils/interceptor.js";

const organizationApi = {
  // 获取组织列表
  getUnitList(params) {
    return request({ url: `/api/pas/organization`, method: "get", params });
  },
  // 根据 id 获取组织详情（用于根据 organizationId 回填组织名称）
  getUnitById(id) {
    return request({ url: `/api/pas/organization/${id}`, method: "get" });
  },
  addUnit(data) {
    return request({ url: `/api/pas/organization`, method: "post",data });
  },
  editUnit(data) {
    return request({ url: `/api/pas/organization/${data.id}`, method: "put",data });
  },
  delUnit(id) {
    return request({ url: `/api/pas/organization/${id}`, method: "delete" });
  },

  // 组织维护（超管）
  getTenantList(params) {
    return request({ url: `/api/pas/tenant-organization`, method: "get", params });
  },
  addTenant(data) {
    return request({ url: `/api/pas/tenant-organization`, method: "post",data });
  },
  editTenant(data) {
    return request({ url: `/api/pas/tenant-organization/${data.id}`, method: "put",data });
  },
  delTenant(id) {
    return request({ url: `/api/pas/tenant-organization/${id}`, method: "delete" });
  },
  getTenantUser(params) {
    return request({ url: `/api/pas/tenant-organization/admin-list`, method: "get",params });
  },
  addTenantUser(data) {
    return request({ url: `/api/pas/tenant-organization/admin`, method: "post",data });
  },
  editTenantUser(data) {
    return request({ url: `/api/pas/tenant-organization/${data.id}/admin`, method: "put",data });
  },
  delTenantUser(id) {
    return request({ url: `/api/pas/tenant-organization/${id}/admin`, method: "delete",data });
  },

  // 获取用户列表
  getUserList(params) {
    return request({ url: `/api/pas/user`, method: "get", params });
  },
  addUser(data) {
    return request({ url: `/api/pas/user`, method: "post", data });
  },
  editUser(data) {
    return request({ url: `/api/pas/user/${data.id}`, method: "put", data });
  },
  delUser(id) {
    return request({ url: `/api/pas/user/${id}`, method: "delete" });
  },
  // 获取部门列表
  getDepartmentList(params) {
    return request({ url: `/api/pas/department`, method: "get", params });
  },

  // 获取评测者列表
  getTesterList(params) {
    return request({ url: `/api/pas/tester`, method: "get", params,isNeedLoading: true });
  },
  getEvaluationList(params) {
    return request({ url: `/api/pas/tester/evaluation-list`, method: "get", params,isNeedLoading: true });
  },
  addTester(data) {
    return request({ url: `/api/pas/tester`, method: "post", data });
  },
  editTester(data) {
    return request({ url: `/api/pas/tester/${data.id}`, method: "put", data });
  },
  delTester(id) {
    return request({ url: `/api/pas/tester/${id}`, method: "delete" });
  },
  getTesterEvaluation(params) {
    return request({ url: `/api/pas/tester-evaluation`, method: "get", params,isNeedLoading: true });
  },
  getTesterWarning(params) {
    return request({ url: `/api/pas/evaluation-statistics/tester-warning`, method: "get", params,isNeedLoading: true });
  },

  // 获取单位报告
  getUnitReportList(params) {
    return request({ url: `/api/pas/organization-report`, method: "get", params });
  },
  addUnitReport(data) {
    return request({ url: `/api/pas/organization-report`, method: "post", data });
  },
  // 导出表格
  exportExcel(data) {
    return request({ url: `/api/pas/tester/export-tester-evaluation-excel`, method: "post", data, timeout: 0 });
  },
  //下载报告 
  downloadReport(params) {
    return request({ url: `/api/pas/generate-report/generate-organization-report/${params.organizationId}`, method: "post" });
  },
  //下载单位报告 
  downloadUnitReport(organizationId) {
    return request({ url: `/api/pas/generate-report/generate-report-file/${organizationId}`, method: "post", timeout: 0 });
  },
  //下载个人报告 
  downloadPeopleReport(testerId) {
    return request({ url: `/api/pas/generate-person-report/people-report/${testerId}`, method: "get" });
  },
  //个人报告全部下载
  downloadAllReport(data) {
    return request({ url: `/api/pas/tester/evaluation-report`, method: "post", data, timeout: 0 });
  },
  //全部下载任务
  downloadAllReportTask(data) {
    return request({ url: `/api/pas/tester/evaluation-report-add-task`, method: "post", data });
  },

  //首页数据
  // getComprehensive(organizationId) {
  //   return request({ 
  //     url: `/api/pas/evaluation-statistics/comprehensive/${organizationId}`,
  //     method: "get",
  //   });
  // },
  getComprehensive(params) {//新加的接口
    return request({ 
      url: `/api/pas/evaluation-statistics/comprehensive-where`,
      method: "get",
      params
    });
  },
  getStatistics(organizationId) {
    return request({ 
      url: `/api/pas/evaluation-statistics/statistics-number/${organizationId}`,
      method: "get",
    });
  },
  // getIndicator(organizationId) {
  //   return request({ 
  //     url: `/api/pas/evaluation-statistics/psycho-and-mshax-indicator-statstics/${organizationId}`,
  //     method: "get",
  //   });
  // },
  getIndicator(params) {//新加的接口
    return request({ 
      url: `/api/pas/evaluation-statistics/psycho-and-mshax-indicator-statstics-where`,
      method: "get",
      params
    });
  },
  // 获取下载列表
  getTaskList(params) {
    return request({ url: `/api/pas/task-background`, method: "get", params });
  }
};

export default organizationApi;
